import { estimateUserOperationGas } from "../../actions/bundler/estimateUserOperationGas.js";
import { getSupportedEntryPoints } from "../../actions/bundler/getSupportedEntrypoints.js";
import { getUserOperationByHash } from "../../actions/bundler/getUserOperationByHash.js";
import { getUserOperationReceipt } from "../../actions/bundler/getUserOperationReceipt.js";
import { sendRawUserOperation } from "../../actions/bundler/sendRawUserOperation.js";
export const bundlerActions = (client) => ({
    estimateUserOperationGas: async (request, entryPoint, stateOverride) => estimateUserOperationGas(client, { request, entryPoint, stateOverride }),
    sendRawUserOperation: async (request, entryPoint) => sendRawUserOperation(client, { request, entryPoint }),
    getUserOperationByHash: async (hash) => getUserOperationByHash(client, { hash }),
    getSupportedEntryPoints: async () => getSupportedEntryPoints(client),
    getUserOperationReceipt: async (hash) => getUserOperationReceipt(client, { hash }),
});
//# sourceMappingURL=bundlerClient.js.map